import api from "../laravelAxiosClient";
import { AssurancesResult } from "../interfaces/assurances.interface";

export const assurancesService = {
  getHistorique: async () => {
    const { data } = await api.get<AssurancesResult>("/assurances/historique");
    return data;
  },
  getAttestationFile: async (assuranceId: string) => {
    const { data } = await api.get<ArrayBuffer>(`/assurances/${assuranceId}/attestation-file`, {
      responseType: "arraybuffer",
    });
    return data;
  },
};
